// extracted by mini-css-extract-plugin
module.exports = {"done":"ForgotPassword_done__1hxQn"};